import React from 'react';
import './style.scss'
import { matchPath } from "react-router-dom";
import { asset } from "../../../helpers/dom.helper";
import {isMobile} from 'react-device-detect';
import { Media, MediaContextProvider } from "../../../media";
import Image from '../../image';

class HeaderTitle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.checkBgImage = !!props.mobileImageUrl
    this.isShowOurReference = props.isShowOurReference
  }

  getIsMatch(pattern) {
    const path = this.props.match?.url
    return !!matchPath(path, { path: pattern })
  }

  getImageHeaderByType() {
    if (isMobile) {
      return  `url(${asset(this.props.mobileImageUrl)})`
    } else {
      return  `url(${asset(this.props.desktopImageUrl)})`
    }
  }

  render() {
    return (
      <div id='headerTitle'>
          <div className={`header-title`} style={{'--foracc-bg-header': this.getImageHeaderByType()}}>
             <MediaContextProvider>
              <div className="container">
                <div className="row">
                  <div className="col-12 text-center">                    
                  <Media greaterThanOrEqual="md">
                    <div className="cover">
                      <h1>{this.props.textHeader}</h1>
                      {this.props.textSubHeader && <p className='mb-0'>{this.props.textSubHeader}</p>}
                      {this.props.textSubHeaderSecondary && <p>{this.props.textSubHeaderSecondary}</p>}
                    </div>
                  </Media>
                  <Media lessThan="md">
                      <div className={`${this.checkBgImage ? 'coverMobile' : ""}`}>
                        <h1>{this.props.textHeader}</h1>
                        {this.props.textSubHeader && <p className='mb-0'>{this.props.textSubHeader}</p>}
                        {this.props.textSubHeaderSecondary && <p>{this.props.textSubHeaderSecondary}</p>}
                      </div>
                  </Media>                    
                  </div>
                </div>
              </div>
            </MediaContextProvider>
          </div>
          {
            this.isShowOurReference &&
            <div className='ourRefContainer'>
            <MediaContextProvider>
              <Media greaterThanOrEqual="md">
                <div className='ourRef pt-3 pb-4'>
                  <h2 className='textHeader'>Our Reference</h2>
                  <div className='referenceLogo'>
                      <div className='imgContainer'>
                        <a href='https://www.bulgari.com/' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/bulgarilogo.webp')}
                            alt="bulgarilogo"
                            className="img-fluid"
                            width="100%"
                            height="auto"
                          />
                        </a>
                      </div>
                      <div className='imgContainer'>
                        <a href='https://www.swatch.com/' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/swatchlogo.webp')}
                            alt="swatchlogo"
                            className="img-fluid"
                            width="100%"
                            height="auto"
                          />
                        </a>
                      </div>
                      <div className='imgContainer'>
                        <a href='https://www.viviennewestwood.com ' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/vivien.webp')}
                            alt="vivien"
                            className="img-fluid"
                            width="100%"
                            height="auto"
                          />
                        </a>
                      </div>
                      <div className='imgContainer'>
                        <a href='https://www.porsche.com/ ' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/porsche.webp')}
                            alt="porsche"
                            className="img-fluid"
                            width="100%"
                            height="auto"
                          />
                        </a>
                      </div>
                      <div className='imgContainer'>
                        <a href='https://www.fourseasons.com ' target="_blank" rel="noopener noreferrer">
                        <Image
                            src={asset('/images/home/reviews/fourSeasons.webp')}
                            alt="fourSeasons"
                            className="img-fluid"
                            width="100%"
                            height="auto"
                          />
                        </a>
                      </div>
                  </div>
                </div>
              </Media>
              <Media lessThan="md">
                <div className='ourRef pt-3 d-flex flex-column'>
                  <h2 className='textHeader'>Our Reference</h2>
                  <div className='referenceLogo d-flex flex-column align-items-center'>                    
                        <a className='text-center' href='https://www.bulgari.com/' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/bulgarilogo.webp')}
                            alt="bulgarilogo"
                            className="img-fluid"
                            height="50%"
                            width="50%"
                          />
                        </a>                    
                        <a className='text-center' href='https://www.swatch.com/' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/swatchlogo.webp')}
                            alt="swatchlogo"
                            className="img-fluid"
                            height="50%"
                            width="50%"
                          />
                        </a>                    
                        <a className='text-center' href='https://www.viviennewestwood.com ' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/vivien.webp')}
                            alt="vivien"
                            className="img-fluid"
                            height="50%"
                            width="50%"
                          />
                        </a>                    
                        <a className='text-center' href='https://www.porsche.com/ ' target="_blank" rel="noopener noreferrer">
                          <Image
                            src={asset('/images/home/reviews/porsche.webp')}
                            alt="porsche"
                            className="img-fluid"
                            height="50%"
                            width="50%"
                          />
                        </a>                    
                        <a className='text-center' href='https://www.fourseasons.com ' target="_blank" rel="noopener noreferrer">
                        <Image
                            src={asset('/images/home/reviews/fourSeasons.webp')}
                            alt="fourSeasons"
                            className="img-fluid"
                            height="50%"
                            width="50%"
                          />
                        </a>
                  </div>
                </div>
              </Media>
            </MediaContextProvider>
            </div>
          }          
      </div>
    );
  }
  
}

export default HeaderTitle;
